module.exports = __webpack_public_path__ + "static/media/203A-1303A.674a21a2.png";